/**
 * Provider profile module slugs used throughout the provider-profile pages.
 * These correspond to the API endpoints under provider-profile/module/{slug}
 */
export const MODULE_KEYS = {
  /** Legacy experience endpoint - used by SitterProfileContent and SkillsPage */
  EXPERIENCE: 'experience',
  /** New experience-profile endpoint - used by DogCareDetailsPage */
  EXPERIENCE_PROFILE: 'experience-profile',
  /** Skills-only endpoint - used by SkillsPage */
  EXPERIENCE_SKILLS: 'experience-skills',
  /** What to expect endpoint - used by WhatToExpectPage */
  EXPERIENCE_WHAT_TO_EXPECT: 'experience-what-to-expect',
  /** Photos module endpoint - used for profile photos */
  PHOTOS_V2: 'photos_v2',
} as const;

export type ModuleKey = (typeof MODULE_KEYS)[keyof typeof MODULE_KEYS];
